import type { AudioBus } from './audio.js';
export class Sfx {
  private lastAt = new Map<string, number>();
  private noiseBuf: AudioBuffer | null = null;
  constructor(private readonly bus: AudioBus) {}
  gun(): void {
    this.play('gun', 45, (ctx, dest, t0) => {
      const src = ctx.createBufferSource();
      src.buffer = this.noise(ctx);
      const bp = ctx.createBiquadFilter();
      bp.type = 'bandpass';
      bp.frequency.value = 2400;
      bp.Q.value = 1.1;
      const g = ctx.createGain();
      g.gain.setValueAtTime(0.16, t0);
      g.gain.exponentialRampToValueAtTime(0.001, t0 + 0.07);
      src.connect(bp);
      bp.connect(g);
      g.connect(dest);
      src.start(t0);
      src.stop(t0 + 0.09);
      const osc = ctx.createOscillator();
      osc.type = 'triangle';
      osc.frequency.setValueAtTime(190, t0);
      osc.frequency.exponentialRampToValueAtTime(70, t0 + 0.06);
      const og = ctx.createGain();
      og.gain.setValueAtTime(0.12, t0);
      og.gain.exponentialRampToValueAtTime(0.001, t0 + 0.07);
      osc.connect(og);
      og.connect(dest);
      osc.start(t0);
      osc.stop(t0 + 0.08);
    });
  }
  thud(): void {
    this.play('thud', 60, (ctx, dest, t0) => {
      const src = ctx.createBufferSource();
      src.buffer = this.noise(ctx);
      const lp = ctx.createBiquadFilter();
      lp.type = 'lowpass';
      lp.frequency.setValueAtTime(900, t0);
      lp.frequency.exponentialRampToValueAtTime(220, t0 + 0.12);
      const g = ctx.createGain();
      g.gain.setValueAtTime(0.3, t0);
      g.gain.exponentialRampToValueAtTime(0.001, t0 + 0.14);
      src.connect(lp);
      lp.connect(g);
      g.connect(dest);
      src.start(t0);
      src.stop(t0 + 0.16);
    });
  }
  crash(): void {
    this.play('crash', 0, (ctx, dest, t0) => {
      const src = ctx.createBufferSource();
      src.buffer = this.noise(ctx);
      const lp = ctx.createBiquadFilter();
      lp.type = 'lowpass';
      lp.frequency.setValueAtTime(3200, t0);
      lp.frequency.exponentialRampToValueAtTime(160, t0 + 0.55);
      const g = ctx.createGain();
      g.gain.setValueAtTime(0.5, t0);
      g.gain.exponentialRampToValueAtTime(0.001, t0 + 0.6);
      src.connect(lp);
      lp.connect(g);
      g.connect(dest);
      src.start(t0);
      src.stop(t0 + 0.62);
      const osc = ctx.createOscillator();
      osc.type = 'sawtooth';
      osc.frequency.setValueAtTime(120, t0);
      osc.frequency.exponentialRampToValueAtTime(32, t0 + 0.4);
      const og = ctx.createGain();
      og.gain.setValueAtTime(0.22, t0);
      og.gain.exponentialRampToValueAtTime(0.001, t0 + 0.45);
      osc.connect(og);
      og.connect(dest);
      osc.start(t0);
      osc.stop(t0 + 0.5);
    });
  }
  private play(
    kind: string,
    throttleMs: number,
    build: (ctx: AudioContext, dest: AudioNode, t0: number) => void,
  ): void {
    if (!this.bus.enabled) return;
    const out = this.bus.output();
    if (!out) return;
    const now = performance.now();
    const last = this.lastAt.get(kind) ?? -Infinity;
    if (now - last < throttleMs) return;
    this.lastAt.set(kind, now);
    try {
      build(out.ctx, out.dest, out.ctx.currentTime + 0.01);
    } catch {}
  }
  private noise(ctx: AudioContext): AudioBuffer {
    if (!this.noiseBuf) {
      const len = Math.floor(ctx.sampleRate * 0.7);
      this.noiseBuf = ctx.createBuffer(1, len, ctx.sampleRate);
      const ch = this.noiseBuf.getChannelData(0);
      for (let i = 0; i < len; i++) ch[i] = Math.random() * 2 - 1;
    }
    return this.noiseBuf;
  }
}
